export default __webpack_public_path__ + "static/media/Back.d3e3e2d7.png";